export enum Environment {
  Local = 'local',
  Development = 'development',
  QA = 'qa',
  Production = 'production'
}
